const PALLET = {
  light: '#fff',
  dark: '#212227',
  overlay: '#000000bf',
  darkHover: '#ffffff1a',
  lightHover: '#0000001a',
  closeButton: '#a5a5a5',
  light2: '#fafafa',
  dark2: '#27282d',
  textDark: '#434343',
  green: '#16C79A',
  greenHover: '#29e7b7',
  dark3: '#494949',
  light3: '#ffffff33',
  dark4: '#333',
  light4: '#bfbfbf',
  textLight: '#ffffff80',
  light5: '#ebebeb',
  dark5: '#ebebeb',
  gray: '#a0a0a0',
  red: '#FF5353',
};

export default {
  '--_wallet-button-color': PALLET.dark2,
  '--_wallet-button-border-color': PALLET.light5,
  '--_wallet-button-hover-border-color': PALLET.light4,
  '--_wallet-button__hover-color': PALLET.darkHover,
  '--_wallet-text-color': PALLET.light,
  '--_loader-circle': PALLET.light,
  '--_ledger-error-text-color': PALLET.light,
  '--_ledger-warning-text-color': PALLET.light,
  '--_ledger-button-background': PALLET.green,
  '--_ledger-button-hover-background': PALLET.greenHover,
  '--_ledger-derivation-border-color': PALLET.light3,
  '--_ledger-derivation-background': PALLET.dark2,
  '--_ledger-derivation-text-color': PALLET.textLight,
  '--_ledger-derivation-active-border-color': PALLET.darkHover,
  '--_ledger-derivation-active-background': PALLET.darkHover,
  '--_ledger-derivation-active-text-color': PALLET.light,
  '--_overlay-color': PALLET.overlay,
  '--_modal-body-color': PALLET.dark,
  '--_close-btn-color': PALLET.closeButton,
  '--_wallet-status-color': PALLET.gray,
  '--_wallet-connected-status-color': PALLET.green,
  '--_wallet-disconnect-button-bg-color': PALLET.red,
  '--_wallet-button-text-color': PALLET.light,
  '--_wallet-footer-border-color': PALLET.darkHover,
  '--_link-color': PALLET.green,
  '--_link-hover-color': PALLET.greenHover,
  '--_tooltip-background': PALLET.light5,
  '--_tooltip-color': PALLET.dark2,
  '--_toast-background': PALLET.gray,
  '--_toast-color': PALLET.textDark,
};
